import React, { useEffect, useState } from 'react'
import {
    CircleMinus,
    Copy,
} from 'lucide-react';

import { useDispatch } from 'react-redux';
import { setToastMessage } from '../../../reducers/common.reducer';
import { getResultsForSingleAgentService, updateRemainBalanceService } from '../../../services/result.service';

const DetailsCopier = (props) => {
    const { date, agentDetailData, fromDateToDate, onClose } = props;
    const [resultDataSingle, setResultDataSingle] = useState();
    const [isLoading, setIsLoading] = useState(false)

    let dispatch = useDispatch()

    async function getResultForSingleAgent() {
        try {
            setIsLoading(true)
            let result = await getResultsForSingleAgentService(date, agentDetailData?.agentId || "0c09fb75-72d5-428d-917c-c6358f139de6")
            if (result.data) {
                setResultDataSingle(result.data)
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                    message: error?.response?.data?.message || error?.message,
                    type: "error",
                })
            );
        }
        finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getResultForSingleAgent();
    }, [date, agentDetailData]);


    const handleCopy = () => {
        const game = resultDataSingle
            .map(item => 
                `${item.gameType.padEnd(8, ' ')} ${Math.round(item.winLoss).toLocaleString()}`
            )
            .join("\n");


// 🔰🔰🔰 🔰🔰🔰 🔰🔰🔰  ဒီကုဒ်ကို ဘေးလိုင်းနဲ့ ခွါလို့ မရပါ - ခွါရင် paste လုပ်တဲ့အခါ ခွါတဲ့အတိုင်းကြီးထွက်လာပါမယ်
    const textToCopy = `
${agentDetailData.agentName}
${fromDateToDate}
-----------
${game}
-----------
Total        ${Math.round(agentDetailData.winLoss).toLocaleString()}
Remain    ${Math.round(agentDetailData.remain - agentDetailData.winLoss).toLocaleString()}
Final        ${Math.round(agentDetailData.remain).toLocaleString()}
`.trim();
//  🔰🔰🔰 🔰🔰🔰 🔰🔰🔰  ဒီကုဒ်ကို ဘေးလိုင်းနဲ့ ခွါလို့ မရပါ - ခွါရင် paste လုပ်တဲ့အခါ ခွါတဲ့အတိုင်းကြီးထွက်လာပါမယ်


        navigator.clipboard.writeText(textToCopy).then(() => {
            dispatch(
                setToastMessage({
                message: "Copied",
                type: "success",
            }))
            onClose()
    })};

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-lg overflow-hidden">
                <div className='flex justify-between items-center p-3 border-b-2 border-dashed bg-slate-100'>
                    <div className='ml-2'>
                        {isLoading && (
                            <div className='flex justify-center items-center'>
                                <div className='w-5 h-5 border-4 border-t-transparent border-blue-500 rounded-full animate-spin'></div>
                            </div>
                        )}
                    </div>
                    <div className='flex justify-end gap-2'>
                        <button
                            className="p-3 bg-blue-700 text-white rounded-md"
                            onClick={handleCopy}
                        >
                            <div className='flex gap-1.5 items-center text-xs'>
                                Copy 
                                <Copy size={14} />
                            </div>
                        </button>
                        <div className='p-3 bg-slate-700 text-white rounded-md'
                            onClick={onClose}>
                            <CircleMinus size={14} />
                        </div>
                    </div>
                </div>

                <div className="px-6 py-4 border-b-2 border-dashed bg-slate-100">
                    <p className="font-bold text-center text-gray-900">
                        <span className='uppercase'>{agentDetailData?.agentName}</span> - {fromDateToDate}
                    </p>
                </div>

                <div className="px-4 my-2 w-80 max-h-[35vh] overflow-y-auto">
                    {resultDataSingle?.map((item, idx) => (
                        <div key={idx} className="grid grid-cols-2 text-sm rounded-md px-2 py-2 hover:bg-slate-100">
                            <p className="text-left text-gray-500">{item?.gameType}</p>
                            <p className="text-right text-gray-500">{Number(item?.winLoss).toLocaleString()}</p>
                        </div>
                    ))}
                </div>

                <div className="border-t-2 text-sm px-6 py-2 space-y-2 border-dashed bg-slate-100">
                    <div className="flex justify-between">
                        <span>Total</span>
                        <span>{Number(agentDetailData?.winLoss).toLocaleString()}</span>
                    </div>

                    <div className="flex justify-between ">
                        <span className='pb-2'>Remain</span>
                        <span className='border-b-2 border-dashed border-gray-400 pb-2'>
                            {Math.round(agentDetailData?.remain - agentDetailData?.winLoss).toLocaleString()}
                        </span>
                    </div>

                    <div className="flex justify-between font-bold py-2">
                        <span>Final</span>
                        <span>{Number(agentDetailData?.remain || 0).toLocaleString()}</span>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DetailsCopier;
